import { useNavigate } from "react-router";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../components/table/Table";
import TableHeader from "../../../components/table/TableHeader";
import { MainPadding } from "../../../styles/Main.styles";
import { useEffect, useState } from "react";
import { useGetInvoices } from "../api/invoice/resolver";
import MainFilterGroup from "../component/MainFilterGroup";
import ExportReportDialog from "../component/ExportReportDialog";
import { Box, Button } from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { useGetInvoiceConstant } from "../api/invoice/constant/resolver";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

export interface MainFilterGroupForm {
  start_date: string;
  end_date: string;
  invoice_type: string;
  payment_method_id: string;
  customer_name: string;
  customer_address?: string;
  customer_phone_number?: string;
  sub_dealer_id?: string;
  payment_due_date?: string;
  status: string;
}

export const KEY_URL_PARAM = {
  start_date: "start_date",
  end_date: "end_date",
  invoice_type: "invoice_type",
  customer_name: "customer_name",
  sub_dealer_id: "sub_dealer_id",
  payment_method_id: "payment_method_id",
  status: "status",
};

export default function Main() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { control, setValue, watch } = useForm<MainFilterGroupForm>();
  const { data: dataRawInvoiceConstant, isLoading: fetchInvoiceConstant } =
    useGetInvoiceConstant();
  const dataInvoiceConstant = dataRawInvoiceConstant?.data.data;
  const { data: dataRawInvoice, isLoading: loadingFetchSupplier } =
    useGetInvoices({
      keyword,
      page,
      perPage,
      invoice_type: watch("invoice_type"),
      status: watch("status"),
      start_date: watch("start_date"),
      end_date: watch("end_date"),
      customer_name: watch("customer_name"),
      payment_method_id: watch("payment_method_id"),
      sub_dealer_id: watch("sub_dealer_id"),
    });
  const dataInvoice = dataRawInvoice?.data.data.data;
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nomor Invoice" },
    { title: "Nama Penerima" },
    { title: "Status" },
    { title: "Keterangan" },
    { title: "Tanggal" },
    { title: "Total" },
  ];
  const body: TableFCBodyProps[] = [
    {
      key: "invoice_number",
      component: (item) => {
        return (
          // <Link href={`invoice/creation/${item.id}`}>
          //   {item.invoice_number}
          // </Link>
          <Box>{item.invoice_number}</Box>
        );
      },
    },
    {
      key: "",
      component: (item) => {
        const name = item?.sub_dealer
          ? item.sub_dealer.sub_dealer_name
          : item.customer_name;
        return <Box onClick={() => handleCellClick(item)}>{name}</Box>;
      },
    },
    {
      key: "",
      component: (item) => {
        let status = "-";
        Object.entries(dataInvoiceConstant?.status || []).forEach((itemObj) => {
          if (itemObj[1] === item.status) {
            status = itemObj[0];
          }
        });
        return <Box onClick={() => handleCellClick(item)}>{status}</Box>;
      },
    },
    { key: "description" },
    { key: "invoice_date", isDate: true },
    { key: "grand_total", isMoney: true },
  ];

  useEffect(() => {
    const allParams = Object.fromEntries(searchParams.entries());
    Object.keys(KEY_URL_PARAM).forEach((item) => {
      if (allParams[item]) {
        setValue(item as any, allParams[item]);
      }
    });
  }, []);

  const handleCellClick = (e: any) => {
    const url = `/invoice/creation/${e.id}`;
    navigate(url);
  };

  return (
    <MainPadding>
      <TableHeader
        addButton
        filterLabel="Search Invoice"
        renderRightButton={
          <Button
            size="small"
            variant="outlined"
            startIcon={<AssessmentIcon />}
          >
            Download Laporan
          </Button>
        }
        renderRight={
          <ExportReportDialog
            defaultStartDate={watch("start_date")}
            defaultEndDate={watch("end_date")}
          />
        }
        renderFilter={
          <Box width={400}>
            <MainFilterGroup control={control} />
          </Box>
        }
        searchBar
        onSearch={(e) => setKeyword(e)}
        onClickAdd={() => navigate("/invoice/creation")}
      />
      <TableFC
        showSkeleton={fetchInvoiceConstant}
        loading={loadingFetchSupplier}
        data={dataInvoice}
        body={body}
        showIndex
        totalRows={dataRawInvoice?.data.data.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={header}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) => handleCellClick(e)}
      />
    </MainPadding>
  );
}
